/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Application_Status_Pending7Inputs */

const en_application_status_pending7 = /** @type {(inputs: Application_Status_Pending7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pending`)
};

const de_application_status_pending7 = /** @type {(inputs: Application_Status_Pending7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausstehend`)
};

/**
* | output |
* | --- |
* | "Pending" |
*
* @param {Application_Status_Pending7Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const application_status_pending7 = /** @type {((inputs?: Application_Status_Pending7Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Application_Status_Pending7Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_application_status_pending7(inputs)
	return en_application_status_pending7(inputs)
});
export { application_status_pending7 as "application_status_PENDING" }